// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8dbf5c6","239":"d9824024","453":"9394e8e6","667":"3e66950c"}[chunkId] + ".chunk.js";
};